/**
 * CR Quick Add
 * Winkelmandje-icoon op productkaarten. Klik opent een flyout met maten;
 * klik op een beschikbare maat voegt direct toe aan het winkelmandje en
 * opent de cart drawer via de eigen events van Impulse (cart:build / cart:open).
 */
(function () {
  if (window.__crQuickAddBound) return;
  window.__crQuickAddBound = true;

  function closeAll(except) {
    document.querySelectorAll('[data-cr-quickadd].is-open').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('is-open');
        var t = el.querySelector('.cr-quickadd__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function addToCart(id, trigger) {
    if (!id) return;
    if (trigger) trigger.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function () {})
      .then(function () { if (trigger) trigger.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.cr-quickadd__toggle');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = toggle.closest('[data-cr-quickadd]');

      // Product met meerdere opties: niets gokken, gewoon de productpagina openen.
      var href = toggle.getAttribute('data-href');
      if (href) { window.location.href = href; return; }

      // Product zonder opties: er valt niets te kiezen, dus direct toevoegen.
      var direct = toggle.getAttribute('data-variant-id');
      if (direct) { addToCart(direct, toggle); return; }
      var willOpen = !wrap.classList.contains('is-open');
      closeAll(wrap);
      wrap.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    var size = e.target.closest('.cr-size');
    if (size) {
      e.preventDefault();
      e.stopPropagation();
      if (size.hasAttribute('disabled')) return;
      addToCart(size.getAttribute('data-variant-id'), size);
      closeAll(null);
      return;
    }

    if (!e.target.closest('[data-cr-quickadd]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
